import type { PluginDefaultTranslationsObject, PluginLanguage } from '../types.js'

export const hyTranslations: PluginDefaultTranslationsObject = {
  $schema: './translation-schema.json',
  'plugin-form-builder': {
    name: 'Անուն (փոքրատառ, առանց հատուկ նիշերի)',
    add: 'Ավելացնել',
    allowedFileTypes: 'Թույլատրված ֆայլերի տեսակները',
    allowedFileTypesDescription:
      'Սահմանափակել թույլատրված ֆայլերի տեսակները (օրինակ՝ պատկեր/*, հավելված/pdf): Թողեք դատարկ՝ բոլոր տեսակները թույլատրելու համար:',
    allowMultipleFiles: 'Թույլատրել բազմաթիվ ֆայլեր',
    amountInCents: 'Գումարը ցենտներով',
    basePrice: 'Բազային գին',
    bcc: 'BCC',
    brand: 'Բրենդ',
    cc: 'ՍԴ',
    checkboxPlural: 'Նշավանդակի դաշտեր',
    checkboxSingular: 'Նշավանդակ',
    checkedByDefault: 'Ստուգված է լռելյայն',
    chooseConfirmationType:
      'Ընտրեք՝ ցուցադրե՞լ էջի հաղորդագրություն, թե՞ վերահղել այլ էջ՝ ձևը ներկայացնելուց հետո:',
    condition: 'Վիճակ',
    confirmationMessage: 'Հաստատման հաղորդագրություն',
    confirmationType: 'Հաստատման տեսակը',
    countryPlural: 'Երկրի դաշտեր',
    countrySingular: 'Երկիր',
    creditCard: 'Վարկային քարտ',
    customURL: 'Հատուկ URL',
    datePlural: 'Ամսաթվի դաշտեր',
    dateSingular: 'Ամսաթիվ',
    defaultValue: 'Կանխադրված արժեք',
    divide: 'Բաժանել',
    documentToLinkTo: 'Փաստաթուղթ, որին կապվելու է',
    doesNotEqual: 'Չի հավասարվում',
    emailFrom: 'Էլ',
    emailPlural: 'Էլփոստի դաշտեր',
    emailsDescription:
      'Ուղարկեք հատուկ նամակներ, երբ ձևը ներկայացվում է: Օգտագործեք ստորակետերով բաժանված ցուցակները՝ միևնույն նամակը բազմաթիվ հասցեատերերին ուղարկելու համար: Այս ձևից արժեքին հղում կատարելու համար այդ դաշտի անունը փաթաթեք կրկնակի գանգուր փակագծերով, այսինքն՝ {{firstName}}: Դուք կարող եք օգտագործել wildcard {{*}}՝ բոլոր տվյալները դուրս բերելու համար, իսկ {{*:table}}՝ դրանք որպես HTML աղյուսակ ձևաչափելու էլ.',
    emailSingular: 'Էլ',
    emailTo: 'Էլ',
    equals: 'Հավասար է',
    field: 'Դաշտ',
    fields: 'Դաշտեր',
    fieldWidth: 'Դաշտի լայնությունը (տոկոս)',
    hasAnyValue: 'Ցանկացած արժեք ունի',
    internalLink: 'Ներքին հղում',
    label: 'Պիտակ',
    maxFileSize: 'Ֆայլի առավելագույն չափը (բայթ)',
    maxFileSizeDescription:
      'Ֆայլի առավելագույն չափը բայթերով: Դատարկ թողեք առանց սահմանափակումների:',
    message: 'Հաղորդագրություն',
    messageDescription: 'Մուտքագրեք հաղորդագրությունը, որը պետք է ուղարկվի այս էլ.',
    messagePlural: 'Հաղորդագրությունների արգելափակումներ',
    messageSingular: 'Հաղորդագրություն',
    mimeType: 'MIME տեսակը',
    mimeTypePlural: 'MIME տեսակները',
    mimeTypeSingular: 'MIME տեսակը',
    multiply: 'Բազմապատկել',
    numberPlural: 'Համարների դաշտեր',
    numberSingular: 'Համար',
    optionPlural: 'Ընտրանքներ',
    optionSingular: 'Տարբերակ',
    paymentFieldPlural: 'Վճարման դաշտեր',
    paymentFieldSingular: 'Վճարում',
    paymentProcessor: 'Վճարման պրոցեսոր',
    paymentStatus: 'Կարգավիճակ',
    placeholder: 'Տեղապահ',
    priceConditions: 'Գնային պայմաններ',
    priceConditionsPlural: 'Գնային պայմաններ',
    priceConditionsSingular: 'Գնային պայման',
    radioOptions: 'Ռադիոյի հատկանիշի ընտրանքներ',
    radioPlural: 'Ռադիոյի դաշտեր',
    radioSingular: 'Ռադիո',
    redirect: 'Վերահղում',
    replyTo: 'Պատասխանել',
    required: 'Պահանջվում է',
    selectOptions: 'Ընտրեք Ընտրանքներ',
    selectPlural: 'Ընտրեք Դաշտեր',
    selectSingular: 'Ընտրել',
    statePlural: 'Պետական դաշտեր',
    stateSingular: 'Պետություն',
    staticValue: 'Ստատիկ արժեք',
    subject: 'Թեմա',
    submitButton: 'Ներկայացրեք կոճակի պիտակը',
    subtract: 'հանել',
    textareaPlural: 'Textarea դաշտեր',
    textareaSingular: 'Textarea',
    textPlural: 'Տեքստային դաշտեր',
    textSingular: 'Տեքստ',
    title: 'Վերնագիր',
    token: 'նշան',
    uploadCollection: 'Վերբեռնել հավաքածուն',
    uploadCollectionDescription: 'Ընտրեք վերբեռնման որ հավաքածուում ֆայլերը պահելու համար',
    uploadFieldPlural: 'Վերբեռնման դաշտեր',
    uploadFieldSingular: 'Վերբեռնել',
    urlToRedirectTo: 'URL վերահղման համար',
    value: 'Արժեք',
    valueOfField: 'Դաշտի արժեքը',
    valueType: 'Արժեքի տեսակը',
  },
}

export const hy: PluginLanguage = {
  dateFNSKey: 'hy-AM',
  translations: hyTranslations,
}
